import { memo, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "stores";
import { getAppState } from "stores/modules/app.state/selectors";
import { appStateMutate } from "stores/modules/app.state/operations";
import { Menu, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { deleteObjectsWithUndo } from "stores/modules/entities.rooms/operations";

const SelectedObjectsMenu = () => {
  const [t] = useTranslation();
  const dispatch = useAppDispatch();
  const selectedObjects = useAppSelector((state) =>
    getAppState(state, "selectedObjects")
  );

  const open = useAppSelector((state) =>
    getAppState(state, "openRoomSelectedObjectsMenu")
  );
  const top = useAppSelector((state) => getAppState(state, "roomPointerY"));
  const left = useAppSelector((state) => getAppState(state, "roomPointerX"));

  const onClose = useCallback(() => {
    dispatch(
      appStateMutate((state) => {
        state.openRoomSelectedObjectsMenu = false;
      })
    );
  }, [dispatch]);

  const onDeleteObjects = useCallback(() => {
    if (
      window.confirm(
        t("{{length}}個のアイテムを削除します。本当によろしいですか？", {
          length: selectedObjects.length,
        })
      )
    ) {
      dispatch(deleteObjectsWithUndo(selectedObjects));
    }
    onClose();
  }, [selectedObjects, dispatch, t, onClose]);

  return (
    <Menu
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={{ left, top }}
      onClose={onClose}
      MenuListProps={{ dense: true }}
      disableRestoreFocus
    >
      <MenuItem onClick={onDeleteObjects}>{t("削除")}</MenuItem>
    </Menu>
  );
};

export default memo(SelectedObjectsMenu);
